import { render, staticRenderFns } from "./ed-homework-student-list.vue?vue&type=template&id=55a0c25f&scoped=true&"
import script from "./ed-homework-student-list.ts?vue&type=script&lang=js&"
export * from "./ed-homework-student-list.ts?vue&type=script&lang=js&"
import style0 from "./ed-homework-student-list.scss?vue&type=style&index=0&id=55a0c25f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0c25f",
  null
  
)

export default component.exports